import styled from 'styled-components';
import { Flex } from 'UI';

export const TopSectionContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
`;

export const SlideStage = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
`;

export const SlidePanel = styled.div<{
  $active: boolean;
  $placement: 'normal' | 'expanded';
  $withCardPadding?: boolean;
}>`
  position: ${({ $active }) => ($active ? 'relative' : 'absolute')};
  inset: ${({ $active }) => ($active ? 'auto' : '0')};
  z-index: ${({ $active }) => ($active ? 2 : 1)};
  width: 100%;
  box-sizing: border-box;
  padding: ${({ $withCardPadding }) => ($withCardPadding ? '8px' : '0')};
  overflow: visible;
  opacity: ${({ $active }) => ($active ? 1 : 0)};
  visibility: ${({ $active }) => ($active ? 'visible' : 'hidden')};
  pointer-events: ${({ $active }) => ($active ? 'auto' : 'none')};
  transform: ${({ $active, $placement }) => {
    if ($active) {
      return 'translateX(0)';
    }
    return $placement === 'normal' ? 'translateX(-80%)' : 'translateX(80%)';
  }};
  transition: opacity 260ms ease-in-out, transform 260ms ease-in-out,
    visibility 0s linear ${({ $active }) => ($active ? '0s' : '260ms')};
`;

export const NormalWidePanel = styled(Flex)`
  width: 100%;
`;
